module.exports = __webpack_public_path__ + "img/bongabong-reading-area.32300b06.jpg";